import React from "react";
import ReactDOM from "react-dom/client";
import { store, persistor } from './store/index';
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/App.scss";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { checkStripeErrorAfterReload } from "./helpers/stripeErrorLogger";
import { initGlobalErrorHandlers, ErrorBoundary } from "./monitoring/errorMonitor";

// Force HTTPS in production
if (window.location.protocol === 'http:' && window.location.hostname !== 'localhost') {
  window.location.replace('https://' + window.location.host + window.location.pathname + window.location.search + window.location.hash);
}

// Boot global handlers before any rendering so no early errors are missed
initGlobalErrorHandlers();

checkStripeErrorAfterReload();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary name="AppRoot">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
